window.subscriptionFlowDrawer = {
    productType : 'platecrate',
    productSize : null,
    frequency : 'monthly',
    shipFrequency : 1,
    giftVariantId :null,
    giftNote :"",
    payFrequency: null,
    subTotal : null,
    crateName: "THIS MONTH'S THEME",
    crateSKU:'surprise',
    variantId:null,
    addItems: [],
    addToCartBtn:null,
    selling_plan_id: null,
    start_date:'',
    end_date:'',
    discount_code:'',
    discount_amount:'',
    discount_type:'',
    per_crate_price:'',
    total: null,
    productPropertyNote:""
  }
class subscriptionFunnelDrawer {
    constructor(){
        //this.getData();
        document.querySelectorAll("[sub_flow]").forEach(ele => {
            ele.addEventListener("click" , (event)=>{
                let subElement = event.currentTarget
                let current_sub = subElement.getAttribute('currentProduct');
                if (current_sub == 'platecrate_pro') {
                    window.subscriptionFlowDrawer.productType = 'platecrate-pro';
                    document.querySelector('.platectate_pr').classList.add('d-none');
                    document.querySelector('.platectatePro_pr').classList.remove('d-none');
                    //document.querySelector("[subscription_type]").innerHTML = 'Plate Crate Pro';
                }else if(current_sub == 'platecrate'){
                    window.subscriptionFlowDrawer.productType = 'platecrate'
                    document.querySelector('.platectate_pr').classList.remove('d-none');
                    document.querySelector('.platectatePro_pr').classList.add('d-none');
                    //document.querySelector("[subscription_type]").innerHTML = 'Plate Crate';
                }
                let size_cookie = Utility.getCookie('size_cookie');
                if(size_cookie == '' || size_cookie == undefined)
                {
                    //document.querySelector("[data_size_dropdown]").dispatchEvent(new Event('change'));
                }else{
                    document.querySelector("[data_size_dropdown]").value = size_cookie;
                    document.querySelector("[data_size_dropdown]").dispatchEvent(new Event('change'));
                }

                document.querySelectorAll("[data-product-type]").forEach(ele=>{
                    let productType = ele.getAttribute("data-product-type");
                    if (productType == window.subscriptionFlowDrawer.productType) {
                      ele.classList.remove("d-none");
                    }else{
                      ele.classList.add("d-none");
                    }
                });
                let flag = false;
                document.querySelectorAll("[data-pay-frequency]").forEach(ele=>{
                    if (flag == false) {
                       if (!ele.closest('[data-product-type]').classList.contains("d-none")) {
                            ele.dispatchEvent(new Event('click'));
                            ele.querySelector("[pay-radio]").checked = true;   
                         flag = true;
                       }
                     }
                });

                document.querySelector('#join-team-subscription-drawer').classList.add('active');
            })
          })

        if (document.querySelectorAll("[data_size_dropdown]").length > 0 ) {
            document.querySelector("[data_size_dropdown]").addEventListener("change",(event)=>{
                let currentEle = event.currentTarget;
                currentEle.classList.remove('border-danger');
                window.subscriptionFlowDrawer.productSize = currentEle.value;
                document.cookie = `size_cookie=${currentEle.value};expires=30;path=/`;
                var getSelectedPay = document.querySelector('[pay-radio]:checked');
                if(getSelectedPay != null ){
                    let current_ele = getSelectedPay.closest('[data-pay-frequency]');
                    //this.setVariantDetails(current_ele);
                    current_ele.dispatchEvent(new Event('click'));
                }
            });
        }

        document.querySelectorAll("[data-pay-frequency]").forEach(ele=>{
            ele.addEventListener("click",(event)=>{
              this._checkPayDetials(event);
            })
        });
        document.querySelector("[data-submit-subscription]").addEventListener("click",(event)=>{
            if(window.subscriptionFlowDrawer.productSize == null){
                document.querySelector('[data_size_dropdown]').classList.add('border-danger');
                window.notificationEle.updateNotification('Cart Error', `Please select a shirt size`, {
                    type: 'error', // success, warning, info, error
                    timeout: 3000 // after how many seconds the notification should disappear
                  });
            }else{
                document.querySelector('[data_size_dropdown]').classList.remove('border-danger');
                window.subscriptionFlowDrawer.addToCartBtn = event.currentTarget;
                window.subscriptionFlowDrawer.addToCartBtn.classList.add('loading');
                this._AddToCart(event);
            }
        });

        document.querySelector('.close_subscription_drawer').addEventListener("click",(event)=>{
            document.querySelector('#join-team-subscription-drawer').classList.remove('active')

        })
        
    }
    _checkPayDetials(event){
        event.stopImmediatePropagation();
        let currentEle = event.currentTarget;
        if(currentEle.closest('[data-product-type]').classList.contains("d-none")){
          return false;
        }
        
        this.setVariantDetails(currentEle);
    
        let mainProductId =  currentEle.getAttribute("main_product_id");
        let payFrequency =  parseInt(currentEle.getAttribute("data-pay-frequency"));
        window.subscriptionFlowDrawer.subTotal = currentEle.getAttribute("data-sub-total");
        window.subscriptionFlowDrawer.subscriptionprice = currentEle.getAttribute("data-subscription-price");
        //window.subscriptionFlowDrawer.freeShipping = currentEle.querySelector("[free_shipping]").innerText;
        window.subscriptionFlowDrawer.payFrequency = payFrequency;
        window.subscriptionFlowDrawer.giftVariantId = currentEle.getAttribute("gift_variant_id");
        window.subscriptionFlowDrawer.giftNote = currentEle.getAttribute("gift_product_note");
        document.querySelector('[subscription_drawer_sub_total]').innerText = window.subscriptionFlowDrawer.subTotal;
      }

    setVariantDetails(ele){
        let mainProductData = JSON.parse(ele.querySelector("[data-main-product-variant]").innerText);
        
        mainProductData = mainProductData.find(x=> x.variant_title == window.subscriptionFlowDrawer.productSize);
        window.subscriptionFlowDrawer.variantId = parseInt(mainProductData.variant_id); 
        window.subscriptionFlowDrawer.selling_plan_id = parseInt(mainProductData.selling_plan_id); 
        window.subscriptionFlowDrawer.discount_amount = mainProductData.discount_amount;
        window.subscriptionFlowDrawer.discount_code = mainProductData.discount_code;
        window.subscriptionFlowDrawer.start_date = mainProductData.start_date;
        window.subscriptionFlowDrawer.end_date = mainProductData.end_date;
        window.subscriptionFlowDrawer.per_crate_price = mainProductData.per_crate_price;
        window.subscriptionFlowDrawer.discount_type = mainProductData.discount_Type;
    };

    async _AddToCart(event){
        if(window.globalVariables.cart.items.length > 0 && window.globalVariables.cart.total_price == 0){
          await this._clear_cart()
        }
        window.subscriptionFlowDrawer.addToCartBtn.querySelector(".spinner").classList.remove("d-block");
        // if(window.globalVariables.templateSuffix == 'subscription-flow' || window.globalVariables.templateSuffix == 'subscription-flow-new-test'){
        //     ga('send', 'event', 'AddToCart', 'Step 5', 'Click on add to cart');
        // } 
        var items = []
         const giftPairId = `gift_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
         let giftProperty = {};
         giftProperty['_main_product_auto_renew_id']=`${window.subscriptionFlowDrawer.variantId}`;
         giftProperty['_gift_pair_id'] = giftPairId;
         giftProperty['_isGiftProduct']='true';
         if(window.subscriptionFlowDrawer.giftNote !== null && window.subscriptionFlowDrawer.giftNote.length>0){
          giftProperty['Note']= window.subscriptionFlowDrawer.giftNote;
         }
      
        if (window.subscriptionFlowDrawer.giftVariantId) {
          items.push( {
            quantity: 1,
            id: parseInt(window.subscriptionFlowDrawer.giftVariantId),
            properties : giftProperty
          });
        }
        
        ttq.track('AddToCart',{  
          content_id: parseInt(window.subscriptionFlowDrawer.variantId),
          quantity: 1,
          value: window.subscriptionFlowDrawer.subTotal,
          currency: 'USD',})
        
        let subscriptionData = {};
        subscriptionData['Shirt Size'] = window.subscriptionFlowDrawer.productSize;
        //subscriptionData['shipping_interval_pay_frequency'] = `${window.subscriptionFlow.payFrequency}`;
        subscriptionData['type_of_subscription'] = window.subscriptionFlowDrawer.frequency;
        //subscriptionData['shipping_interval_frequency'] = `${window.subscriptionFlow.shipFrequency}`;
        //subscriptionData['shipping_interval_unit_type'] = "month";
        //subscriptionData['subscription_id'] = `${window.subscriptionFlow.frequency}-${window.subscriptionFlow.payFrequency}month`;
        // subscriptionData['Age'] = window.subscriptionFlow.age;
        // subscriptionData['Position'] = window.subscriptionFlow.positon;
        //subscriptionData['black_friday_discount_amount'] = '0';
        subscriptionData['product_type'] = window.subscriptionFlowDrawer.productType;
        subscriptionData['is_subscrption'] = true; 
        subscriptionData['_gift_pair_id'] = giftPairId;
        // if ( window.subscriptionFlowDrawer.productType == 'platecrate') {
        subscriptionData['First Crate SKU'] = window.subscriptionFlowDrawer.crateSKU;
        // }
        if ((window.subscriptionFlowDrawer?.productPropertyNote !== "" || window?.subscriptionFlowDrawer?.productPropertyNote?.length>0) && (window.subscriptionFlowDrawer.crateName === "THIS MONTH'S THEME" || window.subscriptionFlowDrawer.productType === "platecrate-pro")) {
          subscriptionData['Note'] = window.subscriptionFlowDrawer.productPropertyNote;
        }
      
        items.push({
          quantity: 1,
          id: parseInt(window.subscriptionFlowDrawer.variantId),
          properties: subscriptionData,
          selling_plan : window.subscriptionFlowDrawer.selling_plan_id
        });
      
        const body = JSON.stringify({
        items: items
        });
      
        fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: body
        })
        .then(async data => {
            window.subscriptionFlowDrawer.addToCartBtn.classList.remove('loading');
             if (window.subscriptionFlowDrawer.discount_code != '') {
              let code = window.subscriptionFlowDrawer.discount_code
              let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/"
              window.location.href = discountApplyUrl;
            }else{
              window.location.href = "/checkout"
            }
        }).catch(e => {
            window.subscriptionFlowDrawer.addToCartBtn.classList.remove('loading');
        });
         }
      
         async _clear_cart(event){
      
          const response_clear = await fetch(`/cart/clear.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
          })
          //  if(response_clear.ok){
          //   this._AddToCart(event);
          //  }
         }




    // getData(){
        
    //     let RouteUrl = `/?sections=subscription-flow`;
        
    //     console.log(RouteUrl,"RouteUrl");
    //     fetch(RouteUrl).then(response => {
    //       return response.json();
    //     }).then(response => {
            
    //         let cartHTML = response['subscription-flow'];
    //         let parser = new DOMParser();
    //         cartHTML = parser.parseFromString(cartHTML, 'text/html');
    //         console.log(cartHTML,"html");
    //         let cartElement = cartHTML.querySelector('#shopify-section-subscription-flow');
    //         document.querySelector('#join-team-subscription-drawer').classList.add('active')
    //         document.querySelector('#join-team-subscription-drawer').innerHTML = cartElement.innerHTML ;
    //         //this._updateCart(response, action);
    //     }).catch((e) => {
    //         console.error(e);
    //     }).finally(() => {
    //         // Cart HTML fetch done
    //      });
    // }
}
new subscriptionFunnelDrawer()
